import { render, staticRenderFns } from "./YbtPayOrder.vue?vue&type=template&id=73706c4c&scoped=true"
import script from "./YbtPayOrder.vue?vue&type=script&lang=js"
export * from "./YbtPayOrder.vue?vue&type=script&lang=js"
import style0 from "./YbtPayOrder.vue?vue&type=style&index=0&id=73706c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73706c4c",
  null
  
)

export default component.exports